let statuslist = ["Lead", "Proposal", "Booked", "Converted", "Cancelled"];
export default statuslist;
